import { TMUIRichTextEditorStyles } from 'mui-rte';

export default () =>
  ({
    overrides: {
      MUIRichTextEditor: {
        root: {
          backgroundColor: '#ffffff',
          width: '100%',
          border: '1px solid #d9d9d6',
          borderRadius: '4px',
          '&:hover': {
            border: '1px solid #63666a'
          }
        },
        editor: {
          maxWidth: '100%',
          padding: '20px',
          minHeight: '250px'
        },
        toolbar: {
          paddingLeft: '20px'
        },
        placeHolder: {
          color: '#888b8d',
          padding: '20px'
        }
      }
    }
  } as TMUIRichTextEditorStyles);
